module.exports = __webpack_public_path__ + "img/logo.671a9dd2.png";